/*jshint -W069 */
/**
 * 
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
    'use strict';

    var Q = require('q');
    var settingsInstance = require('./SettingsInstance.js');
    var customRequest = require('./requestHelper.js').customRequest;
    var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

    function Api(options) {
        var domain = (typeof options === 'object') ? options.domain : options;
        this.domain = domain ? domain : settingsInstance.baseApiUrl;
        if (this.domain.length === 0) {
            throw new Error('Domain parameter must be specified as a string.');
        }
    }

    /**
     * HTTP Request
     * @method
     * @name Api#request
     * @param {string} method - http method
     * @param {string} path - path
     * @param {string} url
     * @param {object} body - body parameters / object
     * @param {object} headers - header parameters
     * @param {object} queryParameters - querystring parameters
     * @param {object} form - form data object
     * @param {object} deferred - promise object
     */
    Api.prototype.request = customRequest;

    /**
     * Usuń obiekty
     * @method
     * @name Api#deleteWarstwyWektoroweByIdObiekty
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID warstwy
     * @param {boolean} parameters.bufor - ID sesji
     * @param {string} parameters.control - Parametr kontrolny
     * @param {string} parameters.token - Token
     * @param {} parameters.body - 
     */
    Api.prototype.deleteWarstwyWektoroweByIdObiekty = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/warstwy_wektorowe/{id}/obiekty',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        parameterPath = parameterPath.replace('{bufor}', parameters['bufor']);

        if (parameters['bufor'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: bufor'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        if (parameters['body'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: body'));
            return deferred.promise;
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('DELETE', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę obiektów dla warstwy jako GeoJSON FeatureCollection
     * @method
     * @name Api#getWarstwyWektoroweByIdObiekty
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID warstwy
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.filter_str - Treść filtra tekstowego pól
     * @param {string} parameters.filter - Treść filtra pól
     * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
     * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
     * @param {number} parameters.date - Filter daty - unix timestamp
     * @param {string} parameters.scope - Jakie wartości pobierane
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getWarstwyWektoroweByIdObiekty = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/warstwy_wektorowe/{id}/obiekty',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['filter_str'] !== undefined) {
            queryParameters['filter_str'] = parameters['filter_str'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        /** set default value **/
        queryParameters['rozwiaz_slowniki'] = 'true';

        if (parameters['rozwiaz_slowniki'] !== undefined) {
            queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
        }

        if (parameters['bbox'] !== undefined) {
            queryParameters['bbox'] = parameters['bbox'];
        }

        if (parameters['date'] !== undefined) {
            queryParameters['date'] = parameters['date'];
        }

        if (parameters['scope'] !== undefined) {
            queryParameters['scope'] = parameters['scope'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę obiektów dla warstwy jako GeoJSON FeatureCollection
     * @method
     * @name Api#postWarstwyWektoroweByIdObiektyAnaliza
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID warstwy
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.filter_str - Treść filtra tekstowego pól
     * @param {string} parameters.filter - Treść filtra pól
     * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
     * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
     * @param {string} parameters.scope - Jakie wartości pobierane
     * @param {string} parameters.control - Parametr kontrolny
     * @param {} parameters.body - 
     */
    Api.prototype.postWarstwyWektoroweByIdObiektyAnaliza = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/warstwy_wektorowe/{id}/obiekty_analiza',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['filter_str'] !== undefined) {
            queryParameters['filter_str'] = parameters['filter_str'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        /** set default value **/
        queryParameters['rozwiaz_slowniki'] = 'true';

        if (parameters['rozwiaz_slowniki'] !== undefined) {
            queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
        }

        if (parameters['bbox'] !== undefined) {
            queryParameters['bbox'] = parameters['bbox'];
        }

        if (parameters['scope'] !== undefined) {
            queryParameters['scope'] = parameters['scope'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę obiektów dla warstwy jako GeoJSON FeatureCollection
     * @method
     * @name Api#getWarstwyWektoroweByIdObiektyNajblizszeWspolrzednych
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID warstwy
     * @param {string} parameters.token - Token
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
     * @param {boolean} parameters.desc - Czy sortowanie zstępne
     * @param {string} parameters.filter_str - Treść filtra tekstowego pól
     * @param {string} parameters.filter - Treść filtra pól
     * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
     * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
     * @param {string} parameters.scope - Jakie wartości pobierane
     * @param {number} parameters.x - Koordynat x punktu
     * @param {number} parameters.y - Koordynat y punktu
     * @param {number} parameters.tolerancja - Tolerancja w metrach
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getWarstwyWektoroweByIdObiektyNajblizszeWspolrzednych = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/warstwy_wektorowe/{id}/obiekty_najblizsze_wspolrzednych',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['order_by'] !== undefined) {
            queryParameters['order_by'] = parameters['order_by'];
        }

        if (parameters['desc'] !== undefined) {
            queryParameters['desc'] = parameters['desc'];
        }

        if (parameters['filter_str'] !== undefined) {
            queryParameters['filter_str'] = parameters['filter_str'];
        }

        if (parameters['filter'] !== undefined) {
            queryParameters['filter'] = parameters['filter'];
        }

        /** set default value **/
        queryParameters['rozwiaz_slowniki'] = 'true';

        if (parameters['rozwiaz_slowniki'] !== undefined) {
            queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
        }

        if (parameters['bbox'] !== undefined) {
            queryParameters['bbox'] = parameters['bbox'];
        }

        if (parameters['scope'] !== undefined) {
            queryParameters['scope'] = parameters['scope'];
        }

        if (parameters['x'] !== undefined) {
            queryParameters['x'] = parameters['x'];
        }

        if (parameters['x'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: x'));
            return deferred.promise;
        }

        if (parameters['y'] !== undefined) {
            queryParameters['y'] = parameters['y'];
        }

        if (parameters['y'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: y'));
            return deferred.promise;
        }

        if (parameters['tolerancja'] !== undefined) {
            queryParameters['tolerancja'] = parameters['tolerancja'];
        }

        if (parameters['tolerancja'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: tolerancja'));
            return deferred.promise;
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz listę obiektów w bbox dla warstwy jako GeoJSON FeatureCollection
     * @method
     * @name Api#postWarstwyWektoroweByIdObiektySelekcja
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.id - ID warstwy
     * @param {string} parameters.token - Token
     * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
     * @param {boolean} parameters.tylko_suma - Czy zwrócić tylko sumę features
     * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
     * @param {} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
     * @param {string} parameters.bbox - Filter bbox "{xmin},{ymin},{xmax},{ymax}"
     * @param {string} parameters.scope - Jakie wartości pobierane
     * @param {string} parameters.control - Parametr kontrolny
     * @param {} parameters.body - 
     */
    Api.prototype.postWarstwyWektoroweByIdObiektySelekcja = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/warstwy_wektorowe/{id}/obiekty_selekcja',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{id}', parameters['id']);

        if (parameters['id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        /** set default value **/
        queryParameters['rozwiaz_slowniki'] = 'true';

        if (parameters['rozwiaz_slowniki'] !== undefined) {
            queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
        }

        if (parameters['tylko_suma'] !== undefined) {
            queryParameters['tylko_suma'] = parameters['tylko_suma'];
        }

        if (parameters['page_number'] !== undefined) {
            queryParameters['page_number'] = parameters['page_number'];
        }

        if (parameters['items_per_page'] !== undefined) {
            queryParameters['items_per_page'] = parameters['items_per_page'];
        }

        if (parameters['bbox'] !== undefined) {
            queryParameters['bbox'] = parameters['bbox'];
        }

        if (parameters['scope'] !== undefined) {
            queryParameters['scope'] = parameters['scope'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        if (parameters['body'] !== undefined) {
            body = parameters['body'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('POST', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    /**
     * Pobierz obiekt jako GeoJSON Feature
     * @method
     * @name Api#getWarstwyWektoroweByLayerIdObiektyByFeatureId
     * @param {object} parameters - method options and parameters
     * @param {string} parameters.layer_id - ID warstwy
     * @param {string} parameters.feature_id - UUID obiektu
     * @param {string} parameters.token - Token
     * @param {boolean} parameters.Czy pobierać z bufora edycji - Token
     * @param {boolean} parameters.rozwiaz_slowniki - Czy słowniki mają być jako opisy
     * @param {string} parameters.control - Parametr kontrolny
     */
    Api.prototype.getWarstwyWektoroweByLayerIdObiektyByFeatureId = function(parameters, options) {
        if (parameters === undefined) {
            parameters = {};
        }
        var deferred = Q.defer();
        var domain = this.domain,
            path = '/warstwy_wektorowe/{layer_id}/obiekty/{feature_id}',
            parameterPath = path;
        var body = {},
            queryParameters = {},
            headers = {},
            form = {},
            files = {};

        headers['Accept'] = ['application/json'];

        parameterPath = parameterPath.replace('{layer_id}', parameters['layer_id']);

        if (parameters['layer_id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: layer_id'));
            return deferred.promise;
        }

        parameterPath = parameterPath.replace('{feature_id}', parameters['feature_id']);

        if (parameters['feature_id'] === undefined) {
            deferred.reject(new Error('Missing required  parameter: feature_id'));
            return deferred.promise;
        }

        if (parameters['token'] !== undefined) {
            queryParameters['token'] = parameters['token'];
        }

        if (parameters['Czy pobierać z bufora edycji'] !== undefined) {
            queryParameters['Czy pobierać z bufora edycji'] = parameters['Czy pobierać z bufora edycji'];
        }

        /** set default value **/
        queryParameters['rozwiaz_slowniki'] = 'true';

        if (parameters['rozwiaz_slowniki'] !== undefined) {
            queryParameters['rozwiaz_slowniki'] = parameters['rozwiaz_slowniki'];
        }

        if (parameters['control'] !== undefined) {
            queryParameters['control'] = parameters['control'];
        }

        queryParameters = mergeQueryParams(parameters, queryParameters);

        this.request('GET', path, domain + parameterPath, body, headers, queryParameters, form, deferred, files, options);

        return deferred.promise;
    };
    return Api;
})();

exports.Api = Api;